<script>
  // The quarter picker, shared by the Comparison panels and the Catalog cube
  // drill-down. Both read the same cubes, so reading them should not be two
  // different skills.
  //
  // `selected` is the caller's state — "all" or one period. It stays outside
  // because what a period filters differs per screen (a set of publisher
  // blocks, or one cube's cells), and only the caller knows how to reapply it.
  // `all` is false when the period values do not add up (survey rounds). The
  // label in front matches the "View as" control next to it.
  let { periods = [], selected = 'all', onselect, all = true, label = 'Period' } = $props();
</script>

{#if periods.length}
  <div class="wf2-row chips" style="gap:6px; flex-wrap:wrap" role="group" aria-label={label}>
    <span class="wf2-caption label">{label}</span>
    {#if all}<button class="chip" class:active={selected === 'all'} onclick={() => onselect('all')}>All periods</button>{/if}
    {#each periods as p}
      <button class="chip" class:active={selected === p} onclick={() => onselect(p)}>{p}</button>
    {/each}
  </div>
{/if}

<style>
  .chips { margin-bottom: var(--space-3); align-items: center; }
  .label { margin-right: 2px; }
  .chip {
    padding: 3px 12px;
    border-radius: 999px;
    border: 1px solid var(--border);
    background: var(--surface-2);
    font-size: .85rem;
    cursor: pointer;
  }
  .chip.active {
    background: color-mix(in srgb, var(--accent), transparent 80%);
    border-color: color-mix(in srgb, var(--accent), transparent 40%);
  }
</style>
